import React, { ChangeEvent, Component, useContext, useState } from "react";
import "./BigCommercePullProductsModal.scss";
import OwButton from "../../../shared/OwButton/OwButton";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import OwCheckbox from "../../../shared/OwCheckbox/OwCheckbox";
import IBigCommercePullProductsDTO from "../../../../models/DTO/IBigCommercePullProductsDTO";
import UserContext from "../../../../contexts/UserContext";
import SupplierContext from "../../../../contexts/SupplierContext";
import { Socket } from "socket.io-client";

type Props = {
    closeModalFn: () => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    startFn: (payload: IBigCommercePullProductsDTO) => void;
};

export const BigCommercePullProductsModal: React.FC<Props> = (props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const [includePhotos, setIncludePhotos] = useState(false);
    const [createProductGroups, setCreateProductGroups] = useState(true);
    const [updateExistingItemsPhotos, setUpdateExistingItemsPhotos] = useState(false);

    const closeModal = () => {
        props.closeModalFn();
    };

    const start = () => {
        const payload: IBigCommercePullProductsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            pullPhotos: includePhotos,
            createProductGroups,
            updateExistingItemsPhotos,
        };

        props.startFn(payload);
    };

    const handleChange = (e: ChangeEvent<any>) => {
        const name = e.target.name;
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;

        switch (name) {
            case "includePhotos":
                setIncludePhotos(value);
                break;

            case "updateExistingItemsPhotos":
                setUpdateExistingItemsPhotos(value);
                break;

            case "createProductGroups":
                setCreateProductGroups(value);
                break;
        }
    };

    return (
        <div className={"BigCommercePullProductsModal p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle leftIconName={"fad fa-cloud-upload-alt"} title={"upload_update"} tag={"h3"} />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModal} />
                    </div>
                </div>
            </div>

            <div>
                <div className="mt-2 mb-2">
                    <OwCheckbox
                        fn={handleChange}
                        name={"includePhotos"}
                        checked={includePhotos}
                        label={"include_photos"}
                        truthyVal={true}
                        falsyVal={false}
                    />
                </div>

                <div className="mt-2 mb-2">
                    <OwCheckbox
                        fn={handleChange}
                        name={"updateExistingItemsPhotos"}
                        checked={updateExistingItemsPhotos}
                        label={"update_existing_item_photos"}
                        truthyVal={true}
                        falsyVal={false}
                    />
                </div>

                <div className="mt-2 mb-2">
                    <OwCheckbox
                        fn={handleChange}
                        name={"createProductGroups"}
                        checked={createProductGroups}
                        label={"create_product_groups"}
                        truthyVal={true}
                        falsyVal={false}
                    />
                </div>

                <div className="mt-2 mb-2">
                    <OwButton fn={start} title={"start"} />
                </div>
            </div>
        </div>
    );
};
